import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../../hooks/useAuth.js';
import { DashboardVendedor } from './DashboardVendedor.js';
import { DashboardRepresentante } from './DashboardRepresentante.js';
import { DashboardGerente } from './DashboardGerente.js';
import { DashboardAdmin } from './DashboardAdmin.js';

// AIDEV-NOTE: Dispatcher que roteia para o dashboard correto baseado em user.perfil
export function DashboardDispatcher() {
  const { user } = useAuth();

  switch (user?.perfil) {
    case 'vendedor':
      return <DashboardVendedor />;
    case 'representante':
      return <DashboardRepresentante />;
    case 'gerente':
      return <DashboardGerente />;
    case 'admin':
      return <DashboardAdmin />;
    default:
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      );
  }
}
